export default {"src":"/_next/static/media/EnterOtp.6c31cf02.svg","height":212,"width":205,"blurWidth":0,"blurHeight":0};